module.exports = __webpack_public_path__ + "static/media/gallery-leaf.fd212c99.svg";